/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';

const ReviewVotes = {

	$domVoteButtons: '.js-company-vote-btn',
	isFetching: false,

	/**
	 * @description Initialize
	 */
	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		$(document).on('click', this.$domVoteButtons, this.handleVote);
	},

	/**
	 * @description Handles add/edit company review
	 */
	handleVote: async function(event) {
		event.preventDefault();

		if (this.isFetching) {
			return;
		}

		this.isFetching = true;

		const $button = $(this);
		const voteType = $button.data('type');
		const reviewId = $button.data('review-id');

		if (!voteType || !reviewId) {
			console.error('Review ID or vote type missing');
			this.isFetching = false;
			return;
		}
		try {
			const response = await fetch(`${window.origin}/wp-json/office-pulse-api/v1/review/vote`, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${window.apiSettings.token}`
				},
				body: JSON.stringify({
					reviewId: reviewId,
					voteType: voteType,
				})
			});

			const result = await response.json();

			if (!response.ok) {
				console.error(result.error || 'Something went wrong');
				this.isFetching = false;
				return;
			}

			console.log(result.review);
			// Update vote counts
			$(`.js-upvote[data-review-id="${result.review.id}"] .company-suggestions__like-num`).text(result.review.upvotes);
			$(`.js-downvote[data-review-id="${result.review.id}"] .company-suggestions__like-num`).text(result.review.downvotes);

			// Remove active class from both buttons
			const $parent = $button.closest('.company-suggestions__item-bottom');
			if (result.voteType === null) {
				$parent.find('.js-upvote').removeClass('active');
				$parent.find('.js-downvote').removeClass('active');
			} else if (result.voteType === 'downvote') {
				$parent.find('.js-upvote').removeClass('active');
				$parent.find('.js-downvote').addClass('active');
			} else if (result.voteType === 'upvote') {
				$parent.find('.js-upvote').addClass('active');
				$parent.find('.js-downvote').removeClass('active');
			}
		} catch (error) {
			console.error('Error:', error);
		} finally {
			this.isFetching = false;
		}
	}
};

export default ReviewVotes;
